import { Component, computed, signal, ChangeDetectionStrategy } from '@angular/core';

import { MdwTimeInput, MdwTimePicker } from '@spaces-ui/meadow/components/date-time';
import { DateUtils, Time } from '@spaces-ui/utils';

import { Sample } from '../../components';

@Component({
  selector: 'app-time-pickers',
  templateUrl: './time-pickers.html',
  styleUrls: ['./time-pickers.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Sample, MdwTimeInput, MdwTimePicker],
})
export class TimePickers {
  public value = signal<Time | undefined>(DateUtils.getTime(new Date()));

  public timeValue = computed(() => {
    const time = this.value();

    if (!time) {
      return undefined;
    }

    return DateUtils.formatTime(time);
  });
}
